export const ArrowLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M12.5 6.66671H0.833313M6.66665 0.833374L0.833313 6.66671L6.66665 12.5" stroke="#A4A7AE" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const ArrowRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M0.833336 6.66671H12.5M6.66667 12.5L12.5 6.66671L6.66667 0.833374" stroke="#A4A7AE" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M7.99999 1.33334L10.06 5.50668L14.6667 6.18001L11.3333 9.42668L12.12 14.0133L7.99999 11.8467L3.87999 14.0133L4.66666 9.42668L1.33333 6.18001L5.93999 5.50668L7.99999 1.33334Z" fill="#F79009" stroke="#F79009" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const HeroIconRight = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="44" height="58" viewBox="0 0 44 58" fill="none">
<path d="M43.1555 30.5946L2.9476 57.679C2.66196 57.8711 2.33012 57.9812 1.98741 57.9978C1.64471 58.0144 1.30397 57.9367 1.0015 57.7731C0.699021 57.6094 0.446136 57.366 0.269773 57.0686C0.0934109 56.7713 0.000177237 56.4311 0 56.0845V1.91554C0.000177237 1.56887 0.0934109 1.22874 0.269773 0.931379C0.446136 0.634014 0.699021 0.390551 1.0015 0.226922C1.30397 0.0632932 1.64471 -0.0143754 1.98741 0.00218957C2.33012 0.0187545 2.66196 0.128933 2.9476 0.320989L43.1555 27.4054C43.4153 27.5805 43.6283 27.8176 43.7756 28.0957C43.9229 28.3739 44 28.6845 44 29C44 29.3155 43.9229 29.6261 43.7756 29.9043C43.6283 30.1824 43.4153 30.4195 43.1555 30.5946Z" fill="white" fillOpacity="0.25"/>
<path d="M1.93945 1.00098C2.09879 1.00874 2.25424 1.05937 2.38867 1.14941V1.15039L42.5967 28.2344C42.7193 28.317 42.8209 28.43 42.8916 28.5635C42.9624 28.6971 43 28.8473 43 29C43 29.1527 42.9624 29.3029 42.8916 29.4365C42.8209 29.57 42.7193 29.683 42.5967 29.7656L2.38867 56.8496C2.25414 56.9398 2.09897 56.9913 1.93945 56.999C1.77956 57.0068 1.61982 56.9705 1.47754 56.8936C1.33514 56.8165 1.21445 56.7012 1.12988 56.5586C1.04527 56.4159 1.00009 56.2518 1 56.084V1.91602L1.00879 1.79102C1.02551 1.66745 1.06645 1.54835 1.12988 1.44141C1.21445 1.29884 1.33515 1.18347 1.47754 1.10645C1.61982 1.02952 1.77957 0.993249 1.93945 1.00098Z" stroke="white" strokeOpacity="0.1" strokeWidth="2"/>
</svg>
)

export const HeroIconLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="58" viewBox="0 0 44 58" fill="none">
<path d="M0.844494 30.5946L41.0524 57.679C41.338 57.8711 41.6699 57.9812 42.0126 57.9978C42.3553 58.0144 42.696 57.9367 42.9985 57.7731C43.301 57.6094 43.5539 57.366 43.7302 57.0686C43.9066 56.7713 43.9998 56.4311 44 56.0845V1.91554C43.9998 1.56887 43.9066 1.22874 43.7302 0.931379C43.5539 0.634014 43.301 0.390551 42.9985 0.226922C42.696 0.0632932 42.3553 -0.0143754 42.0126 0.00218957C41.6699 0.0187545 41.338 0.128933 41.0524 0.320989L0.844494 27.4054C0.584713 27.5805 0.371716 27.8176 0.2244 28.0957C0.0770798 28.3739 0 28.6845 0 29C0 29.3155 0.0770798 29.6261 0.2244 29.9043C0.371716 30.1824 0.584713 30.4195 0.844494 30.5946Z" fill="white" fillOpacity="0.25"/>
<path d="M42.0605 1.00098C41.9012 1.00874 41.7458 1.05937 41.6113 1.14941V1.15039L1.40332 28.2344C1.28073 28.317 1.17914 28.43 1.1084 28.5635C1.03762 28.6971 1 28.8473 1 29C1 29.1527 1.03762 29.3029 1.1084 29.4365C1.17914 29.57 1.28073 29.683 1.40332 29.7656L41.6113 56.8496C41.7459 56.9398 41.901 56.9913 42.0605 56.999C42.2204 57.0068 42.3802 56.9705 42.5225 56.8936C42.6649 56.8165 42.7856 56.7012 42.8701 56.5586C42.9547 56.4159 42.9999 56.2518 43 56.084V1.91602L42.9912 1.79102C42.9745 1.66745 42.9335 1.54835 42.8701 1.44141C42.7855 1.29884 42.6649 1.18347 42.5225 1.10645C42.3802 1.02952 42.2204 0.993249 42.0605 1.00098Z" stroke="white" strokeOpacity="0.1" strokeWidth="2"/>
</svg>
)

export const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 7V12L15 14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const DocumentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 13H16M8 17H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const FolderIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 8C3 6.34315 4.34315 5 6 5H9.17157C9.70201 5 10.2107 5.21071 10.5858 5.58579L12 7H18C19.6569 7 21 8.34315 21 10V17C21 18.6569 19.6569 20 18 20H6C4.34315 20 3 18.6569 3 17V8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const ZapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const DatabaseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 5C16.4183 5 20 6.34315 20 8C20 9.65685 16.4183 11 12 11C7.58172 11 4 9.65685 4 8C4 6.34315 7.58172 5 12 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 8V16C4 17.6569 7.58172 19 12 19C16.4183 19 20 17.6569 20 16V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 12C20 13.6569 16.4183 15 12 15C7.58172 15 4 13.6569 4 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7 4.5V19.5C7 20.3161 7.9068 20.8047 8.585 20.352L20.085 12.852C20.6976 12.4468 20.6976 11.5532 20.085 11.148L8.585 3.648C7.9068 3.19527 7 3.68391 7 4.5Z" fill="currentColor"/>
  </svg>
)

export const PauseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="6" y="4" width="4" height="16" rx="1" fill="currentColor"/>
    <rect x="14" y="4" width="4" height="16" rx="1" fill="currentColor"/>
  </svg>
)

export const NetworkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="6" cy="12" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="18" cy="12" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="12" cy="19" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M12 7V17M10.5 6.3L7.5 10.5M13.5 6.3L16.5 10.5M8 13L10.3 17M16 13L13.7 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

export const ChartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7 20V13M12 20V4M17 20V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const SparkleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 3L13.4 9.6L20 11L13.4 12.4L12 19L10.6 12.4L4 11L10.6 9.6L12 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
)

export const ChevronDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M13.3334 4L6.00008 11.3333L2.66675 8" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const AppleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M15.7 10.53c-.03-2.05 1.68-3.03 1.76-3.08-.96-1.4-2.45-1.6-2.98-1.62-1.27-.13-2.48.75-3.12.75-.65 0-1.63-.73-2.68-.71-1.38.02-2.65.8-3.36 2.03-1.43 2.48-.37 6.16 1.03 8.18.68.98 1.5 2.09 2.57 2.05 1.03-.04 1.42-.66 2.67-.66 1.24 0 1.6.66 2.68.64 1.11-.02 1.81-1 2.48-1.99.78-1.14 1.1-2.24 1.11-2.3-.02-.01-2.14-.82-2.16-3.29Z" fill="currentColor"/>
    <path d="M13.62 4.28c.56-.68.94-1.62.83-2.56-.81.03-1.79.54-2.37 1.21-.52.6-.97 1.56-.85 2.48.9.07 1.82-.46 2.39-1.13Z" fill="currentColor"/>
  </svg>
)

export const GooglePlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M3.6 2.3c-.3.3-.5.75-.5 1.32v12.76c0 .57.2 1.02.5 1.32l.09.08 7.15-7.15v-.17L3.69 2.22l-.09.08Z" fill="currentColor"/>
    <path d="M13.2 12.94l-2.36-2.36v-.17l2.36-2.36.05.03 2.8 1.59c.8.45.8 1.2 0 1.65l-2.8 1.59-.05.03Z" fill="currentColor"/>
    <path d="M13.25 12.91 10.84 10.5 3.6 17.74c.27.28.71.32 1.21.04l8.44-4.87Z" fill="currentColor"/>
    <path d="M13.25 8.09 4.81 3.22c-.5-.28-.94-.24-1.21.04l7.24 7.24 2.41-2.41Z" fill="currentColor"/>
  </svg>
)

export const TrophyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M8 21H16M12 17V21M7 4H17V9C17 11.7614 14.7614 14 12 14C9.23858 14 7 11.7614 7 9V4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 5H4V7C4 8.65685 5.34315 10 7 10M17 5H20V7C20 8.65685 18.6569 10 17 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const TrendingUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 17L9 11L13 15L21 7M21 7H15M21 7V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M23 21V19C22.9986 17.1771 21.765 15.5857 20 15.13M16 3.13C17.7699 3.58317 19.0078 5.17799 19.0078 7.005C19.0078 8.83201 17.7699 10.4268 16 10.88" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 1.5V10.5M8 10.5L11.5 7M8 10.5L4.5 7M2 12.5V13.5C2 14.05 2.45 14.5 3 14.5H13C13.55 14.5 14 14.05 14 13.5V12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M13.3334 6.66667C13.3334 10.6667 8.00002 14.6667 8.00002 14.6667C8.00002 14.6667 2.66669 10.6667 2.66669 6.66667C2.66669 5.25218 3.22859 3.89563 4.22878 2.89543C5.22898 1.89524 6.58553 1.33334 8.00002 1.33334C9.41451 1.33334 10.7711 1.89524 11.7713 2.89543C12.7715 3.89563 13.3334 5.25218 13.3334 6.66667Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.00002 8.66667C9.10459 8.66667 10 7.77124 10 6.66667C10 5.5621 9.10459 4.66667 8.00002 4.66667C6.89545 4.66667 6.00002 5.5621 6.00002 6.66667C6.00002 7.77124 6.89545 8.66667 8.00002 8.66667Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const SwapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M2 5.33334H12.6667L10 2.66667M14 10.6667H3.33333L6 13.3333" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const ChatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M14 7.33334C14.0035 8.16523 13.8054 8.98576 13.4227 9.7245C12.9686 10.6082 12.2793 11.3487 11.4315 11.8637C10.5837 12.3787 9.6106 12.6479 8.62 12.6417C7.78811 12.6452 6.96758 12.4471 6.22867 12.0643L2 13.3333L3.26933 9.10467C2.8866 8.36576 2.68843 7.54523 2.692 6.71334C2.68575 5.72274 2.95493 4.74968 3.46992 3.90188C3.98491 3.05408 4.72538 2.36477 5.60933 1.91067C6.34807 1.52794 7.16861 1.32977 8 1.33334H8.31333C9.62129 1.40418 10.8574 1.95491 11.7889 2.87889C12.7204 3.80287 13.2822 5.03899 13.36 6.34667L14 7.33334Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const RouteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="3.33333" cy="4" r="1.66667" stroke="currentColor" strokeWidth="1.33333"/>
    <circle cx="12.6667" cy="12" r="1.66667" stroke="currentColor" strokeWidth="1.33333"/>
    <path d="M5 4H10C11.1046 4 12 4.89543 12 6V8C12 9.10457 11.1046 10 10 10H6C4.89543 10 4 10.8954 4 12V12" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round"/>
  </svg>
)

export const EyeBrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M1.75 4.08333V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H4.08333" stroke="#FE6C00" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.91666 1.75H11.0833C11.3927 1.75 11.6895 1.87292 11.9083 2.09171C12.1271 2.3105 12.25 2.60725 12.25 2.91667V4.08333" stroke="#FE6C00" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.25 9.91675V11.0834C12.25 11.3928 12.1271 11.6896 11.9083 11.9084C11.6895 12.1272 11.3927 12.2501 11.0833 12.2501H9.91666" stroke="#FE6C00" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.08333 12.2501H2.91667C2.60725 12.2501 2.3105 12.1272 2.09171 11.9084C1.87292 11.6896 1.75 11.3928 1.75 11.0834V9.91675" stroke="#FE6C00" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.08334 7H9.91667" stroke="#FE6C00" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <g clipPath="url(#clip0_11_9291)">
    <path d="M1.75 6.4165L12.8333 1.1665L7.58333 12.2498L6.41667 7.58317L1.75 6.4165Z" stroke="#FE6C00" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_11_9291">
    <rect width="14" height="14" fill="white"/>
    </clipPath>
    </defs>
  </svg>
)

export const ContactArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
<path d="M10.2955 15.3611C10.3225 15.4281 10.3692 15.4854 10.4296 15.5251C10.49 15.5648 10.5611 15.5851 10.6333 15.5832C10.7055 15.5814 10.7755 15.5575 10.8338 15.5147C10.892 15.472 10.9358 15.4124 10.9593 15.3441L15.5634 1.88572C15.5861 1.82296 15.5904 1.75504 15.5759 1.68991C15.5614 1.62478 15.5286 1.56513 15.4814 1.51794C15.4342 1.47076 15.3746 1.43798 15.3094 1.42346C15.2443 1.40894 15.1764 1.41326 15.1136 1.43593L1.65529 6.0401C1.58694 6.06354 1.52739 6.10733 1.48464 6.1656C1.44189 6.22386 1.41798 6.2938 1.41613 6.36605C1.41428 6.43829 1.43457 6.50936 1.47429 6.56974C1.514 6.63011 1.57123 6.6769 1.63829 6.70381L7.25538 8.95631C7.43295 9.0274 7.59428 9.13372 7.72965 9.26885C7.86503 9.40397 7.97163 9.56512 8.04304 9.74256L10.2955 15.3611Z" fill="white" stroke="white" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M15.4796 1.52051L7.73047 9.26897" stroke="white" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
)